















































import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'
// import memberOrDeptSelect from '@/components/commonForm/memberOrDeptSelect.vue'
import widgetCommon from './widgetCommon'
import {selectE} from './types'
import {difference, intersection} from 'lodash'
import widgetPop from './widgetPop'
import {AppModule} from '@/store/modules/app'
import {cloneDeep} from 'lodash'
import {cascadeRule} from './ruleConfig'
function filterOptions (options) {
  return options.filter((item) => {
    if (item.isDelete !== 1) {
      let children = filterOptions(item.children || [])
      item.children = children.length ? children : null
      return true
    }
  })
}
function optionsMapFn (options, obj = {}, pId = 0) {
  options.forEach(({key, value, children}) => {
    obj[key] = {key, value, pId}
    optionsMapFn(children || [], obj, key)
  })
  return obj
}
@Component({
  components: {
    // memberOrDeptSelect
  }
})
export default class extends Mixins(widgetCommon, widgetPop) {
  private popupValue: any = ''
  private deps: any = []
  private currentOptions = []
  private isFilter = false
  private get options () {
    return filterOptions(cloneDeep(this.item.options))
  }
  private get currentSelect () {
    let v = this.form[this.item.businessId] || []
    return v.map((id) => {
      return this.optionsMap[id] && this.optionsMap[id].value
    })
  }
  private get rules () {
    return cascadeRule(this.item, this.commonRule)
  }
  private get optionsMap () {
    return optionsMapFn(this.item.options)
  }
  public mounted () {
    if (this.type === 'record') {
      this.initField()
    }
  }
  private changIndex (item) {
    if (item.children) {
      this.currentOptions = item.children
    }
  }
  private close (item) {
    this.popupValue = ''
  }
  private comfirm () {
    this.form[this.item.businessId] = this.getPathObj(this.popupValue).map((item) => item.key)
    this.changeStatus(false)
  }
  private open () {
    if (this.disabled) {
      return 
    }
    this.changeStatus(true)
    this.currentOptions = this.options
    let v = this.form[this.item.businessId]
    if (v && v.length) {
      this.popupValue = v[v.length - 1]
    } else {
      this.popupValue = ''
    }
  }
  private clear () {
    this.popupValue = ''
  }
  private getPathObj(id) {
    let arr: any[] = []
    let depMap = this.optionsMap
    let current = depMap[id]
    if (!current) {
      return []
    }
    arr.unshift(current)
    while (current.pId) {
      let pNode: any = depMap[current.pId]
      if (pNode) {
        arr.unshift(pNode)
        current = pNode
      } else {
        break
      }
    }
    return arr
  }
  private initField () {
    if (!this.isUndef(this.form[this.item.businessId])) {
      return
    }
    this.form[this.item.businessId] = []
  }
}
